<script>
import each from 'lodash/each';
import isEqual from 'lodash/isEqual';
import vueMixins from 'viralstyle-ui/src/vueMixins';
import VsButton from 'viralstyle-ui/src/VsButton';
import VsLayout from 'viralstyle-ui/src/VsLayout';
import VsModal from 'viralstyle-ui/src/VsModal';
import { mapState } from 'vuex';

import PaymentCheck from 'domains/settings/SettingsPayment/SettingsPaymentCheck';
import PaymentAch from 'domains/settings/SettingsPayment/SettingsPaymentAch';
import PaymentWire from 'domains/settings/SettingsPayment/SettingsPaymentWire';
import PaymentPaypal from 'domains/settings/SettingsPayment/SettingsPaymentPaypal';
import PaymentPayoneer from 'domains/settings/SettingsPayment/SettingsPaymentPayoneer';
import PaymentPingpong from 'domains/settings/SettingsPayment/SettingsPaymentPingpong';
import { paymentWireValidator, paymentCheckValidator, paymentAchValidator, paymentPaypalValidator } from 'domains/settings/_settings-validator';

export default {
  components: {
    VsButton,
    VsModal,
    VsLayout,
    PaymentCheck,
    PaymentAch,
    PaymentWire,
    PaymentPaypal,
    PaymentPayoneer,
    PaymentPingpong,
  },
  mixins: [vueMixins],
  data: () => ({
    paymentWireValidator,
    paymentCheckValidator,
    paymentAchValidator,
    paymentPaypalValidator,
  }),
  computed: {
    ...mapState({
      processing: state => state.processing,
      paymentInfo: state => state.settings.paymentInfo,
      paymentModals: state => state.settings.paymentModals,
      currentPayoneerAccountId: state => state.settings.currentPayoneerAccountId,
      currentPingpongAccountId: state => state.settings.currentPingpongAccountId,
      originalPaymentInfo: state => state.settings.originalPaymentInfo,
    }),
  },
  methods: {
    $_validateAndSavePayout(saveMethod, method, validator, paymentMethodInfo, paymentInfo = {}, skipSavePayment) {
      this.$store.dispatch('validateAndSavePayout', { saveMethod, method, validator, paymentMethodInfo, paymentInfo, routeName: this.$route.name, skipSavePayment });
    },
    closePaymentModal(modal) {
      this.$store.commit('togglePaymentModal', { modal, value: false });

      this.$store.commit('lockScroll', false);
    },
    saveAndRequestBank() {
      this.$_validateAndSavePayout('BANK_CHECK', 'BANK', paymentCheckValidator, this.paymentInfo.bank_check_details, {}, isEqual(this.paymentInfo.bank_check_details, this.originalPaymentInfo.bank_check_details));
    },
    saveAndRequestAch() {
      this.$_validateAndSavePayout('ACH', 'ACH', paymentAchValidator, this.paymentInfo.ach_details, {}, isEqual(this.paymentInfo.ach_details, this.originalPaymentInfo.ach_details));
    },
    saveAndRequestWire() {
      this.$_validateAndSavePayout('WIRE', 'WIRE', paymentWireValidator, this.paymentInfo.wire_details, {}, isEqual(this.paymentInfo.wire_details, this.originalPaymentInfo.wire_details));
    },
    saveAndRequestPaypal() {
      this.$_validateAndSavePayout(
        { method: 'PAYPAL', prettyName: 'PayPal' },
        'PAYPAL',
        paymentPaypalValidator,
        { paypal_email: this.paymentInfo.paypal_email },
        { email: this.paymentInfo.paypal_email },
        this.originalPaymentInfo.paypal_email === this.paymentInfo.paypal_email,
      );
    },
    saveAndRequestPayoneer() {
      let currentPayoneerAccountId = this.currentPayoneerAccountId;

      if (!currentPayoneerAccountId) {
        each(this.paymentInfo.payoneer_accounts, account => {
          if (account.is_default) {
            currentPayoneerAccountId = account.account_id;
          }
        });
      }

      if (this.$route.name.indexOf('settingsPayoutsReferrals') !== -1) {
        this.$store.dispatch('requestReferralPayout', { method: 'PAYONEER', paymentInfo: { payoneer_account_id: currentPayoneerAccountId } });
      } else if (this.$route.name.indexOf('settingsPayoutsAffiliate') !== -1) {
        this.$store.dispatch('requestAffiliatePayout', { payment_method: 'PAYONEER', payment_info: { payoneer_account_id: currentPayoneerAccountId } });
      } else if (this.$route.name.indexOf('settingsPayoutsCampaigns') !== -1) {
        this.$store.dispatch('requestCampaignPayout', { payment_method: 'PAYONEER', payment_info: { payoneer_account_id: currentPayoneerAccountId } });
      } else {
        this.$store.commit('addNotification', 'Payoneer payout method not supported yet.');
      }

      this.closePaymentModal('payoneer');
    },
    saveAndRequestPingpong() {
      let currentPingpongAccountId = this.currentPingpongAccountId;

      if (!currentPingpongAccountId) {
        each(this.paymentInfo.pingpong_accounts, account => {
          if (account.is_default) {
            currentPingpongAccountId = account.account_id;
          }
        });
      }

      if (this.$route.name.indexOf('settingsPayoutsReferrals') !== -1) {
        this.$store.dispatch('requestReferralPayout', { method: 'PINGPONG', paymentInfo: { pingpong_account_id: currentPingpongAccountId } });
      } else if (this.$route.name.indexOf('settingsPayoutsAffiliate') !== -1) {
        this.$store.dispatch('requestAffiliatePayout', { payment_method: 'PINGPONG', payment_info: { pingpong_account_id: currentPingpongAccountId } });
      } else if (this.$route.name.indexOf('settingsPayoutsCampaigns') !== -1) {
        this.$store.dispatch('requestCampaignPayout', { payment_method: 'PINGPONG', payment_info: { pingpong_account_id: currentPingpongAccountId } });
      } else {
        this.$store.commit('addNotification', 'PingPong payout method not supported yet.');
      }

      this.closePaymentModal('pingpong');
    },
    registerPayoneer() {
      this.$store.dispatch('registerPayoneer');
    },
    registerPingpong() {
      this.$store.dispatch('registerPingpong');
    },
  },
};
</script>

<template lang='pug'>
div
  vs-modal(v-if='paymentModals.bank', @close='closePaymentModal("bank")')
    div(slot='body')
      payment-check(hide-submit)
    div(slot='footer')
      vs-button(
        text='request payout',
        icon='cash',
        :processing='processing',
        :disabled='processing',
        @click='saveAndRequestBank',
      )

  vs-modal(v-if='paymentModals.ach', @close='closePaymentModal("ach")')
    div(slot='body')
      payment-ach(hide-submit)
    div(slot='footer')
      vs-button(
        text='request payout',
        icon='cash',
        :processing='processing',
        :disabled='processing',
        @click='saveAndRequestAch',
      )

  vs-modal(v-if='paymentModals.wire', @close='closePaymentModal("wire")')
    div(slot='body')
      payment-wire(hide-submit)
    div(slot='footer')
      vs-button(
        text='request payout',
        icon='cash',
        :processing='processing',
        :disabled='processing',
        @click='saveAndRequestWire',
      )

  vs-modal(v-if='paymentModals.paypal', @close='closePaymentModal("paypal")')
    div(slot='body')
      payment-paypal(hide-submit)
    div(slot='footer')
      vs-button(
        text='request payout',
        icon='cash',
        :processing='processing',
        :disabled='processing',
        @click='saveAndRequestPaypal',
      )

  vs-modal(v-if='paymentModals.payoneer', @close='closePaymentModal("payoneer")')
    div(slot='body')
      payment-payoneer(selectable, modal)
    div(slot='footer')
      vs-layout(v-if='get(paymentInfo, "payoneer_accounts.length")', wrap-xs, space-between-xs)
        vs-layout(sm='6', lg='5')
          vs-button(
            full-width,
            text='Connect Another Payoneer<sup>®</sup> Account',
            :processing='processing',
            :disabled='processing',
            @click='registerPayoneer',
          )
        vs-layout(sm='6', md='4')
          vs-button.payoneer-request(
            full-width,
            text='request payout',
            icon='cash',
            :processing='processing',
            :disabled='processing',
            @click='saveAndRequestPayoneer',
          )

  vs-modal(v-if='paymentModals.pingpong', @close='closePaymentModal("pingpong")')
    div(slot='body')
      payment-pingpong(selectable, modal)
    div(slot='footer')
      vs-layout(v-if='get(paymentInfo, "pingpong_accounts.length")', wrap-xs, space-between-xs)
        vs-layout(sm='6', lg='5')
          vs-button(
            full-width,
            text='Connect Another PingPong Account',
            :processing='processing',
            :disabled='processing',
            @click='registerPingpong',
          )
        vs-layout(sm='6', md='4')
          vs-button.payoneer-request(
            full-width,
            text='request payout',
            icon='cash',
            :processing='processing',
            :disabled='processing',
            @click='saveAndRequestPingpong',
          )
</template>

<style>
@import '~import/index';

.payoneer-request {
  margin-top: 1rem;

  @include mq(mf-sm) {
    margin-top: 0;
  }
}
</style>